import { useFetch } from "matsuri-hooks"
import { City } from "@/domain/city"
import { listCities } from "@/endpoints/m2m-core.v1"

interface UseCityInput {
    prefectureId: string
}

export const useCities = (input: UseCityInput) => {
    return useFetch<City[]>(listCities({ id: input.prefectureId }), {
        method: "GET"
    })
}
